import * as React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { PRINCIPAL_INVESTIGATOR, QUALITY_REVIEWER } from "../../utilities";
import { useState, useEffect } from "react";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
 
};
export default function PopUpModal({ handleOpen,onConfirm, open,actionbtn,close, handleClose, msg, title }) {
  const handleConfirm = () => {
    // setIsOpen(false);
    onConfirm();
  };
  
  return (
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        hideBackdrop={false}
        // disableEnforceFocus 
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <img src={title==="Warning"?"./images/icons/party_danger.svg":"./images/icons/party_popper.svg"} alt="" />
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <div className="d-flex flex-column align-items-center">
            <div className="text-center">
                {/* <h3>{title}</h3> */}
                <h3 style={{ color: title === 'Warning' ? 'red' : '' }}>{title}</h3>
                {/* <p>{msg}</p> */}
                <p><span className="lower">{msg}</span></p>
            </div>
              <div className="d-flex justify-content-between gap-4">
                  {/* <button className={`white_btn ${close.length<=7? 'px-4':'px-3'}`} onClick={handleClose}>{close}</button> */}
                  {actionbtn && <button className={`${
    actionbtn === 'Close' ? 'gray_btn' : 'orange_btn'
  } ${actionbtn.length <= 7 ? 'px-4' : 'px-3'}`} onClick={handleConfirm}>{actionbtn}</button>}
              </div>
          </div>
          </Typography>
        </Box>
      </Modal>
  );
}
export function PopUpAlert({getPiQrRadioVal, handleOpen,onConfirm,sendBackConfirmation, sendbackmsg, open,actionbtn,close, handleClose, msg, title }) {
  const RolesArray = [
    {name:"Principal Investigator", id:PRINCIPAL_INVESTIGATOR}, 
    {name:"Quality Reviewer", id:QUALITY_REVIEWER}]
    const [radioId, setRadioId] = useState('')

useEffect(() => {
  if(open){
    setRadioId('')
  }
}, [open])


  const handleConfirm = () => {
    onConfirm();
  };
  const handleRadioChange=(e, i)=>{
   setRadioId(i.id)
   getPiQrRadioVal(i.id)
  }
 
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      hideBackdrop={false}
      disableEscapeKeyDown={true}
    // disableEnforceFocus={true}
    >
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {/* <img src="./images/icons/party_popper.svg" alt="" /> */}
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 1 }}>
          <div className="d-flex flex-column align-items-center">
            <div className="text-center">
              <p><span className="lower lh-base mb-3">{msg}</span></p>
              {sendBackConfirmation && <div>

                <div className="d-flex gap-4">
                  {RolesArray?.map(i => {
                    return (
                      <div className="" key={i.id}>
                        <label htmlFor={i.id === radioId} className="d-flex align-items-center gap-2">
                          <input type="radio" id="topi" checked={i.id === radioId} value={i.id} onChange={(e) => handleRadioChange(e, i)} />
                          {i.name}</label>
                      </div>

                    )
                  })}

                </div>
              </div>}
            </div>
            <div className="d-flex justify-content-between gap-4">
              <button className={`white_btn ${close.length <= 5 ? 'px-4' : 'px-3'}`} onClick={handleClose}>{close}</button>
              {actionbtn && !sendBackConfirmation && <button className={`orange_btn ${actionbtn.length <= 7 ? 'px-4' : 'px-3'}`} onClick={handleConfirm}>{actionbtn}</button>}
              {actionbtn && sendBackConfirmation && <button className={`orange_btn ${actionbtn.length <= 7 ? 'px-4' : 'px-3'}`} onClick={handleConfirm} disabled={radioId === ''}>{actionbtn}</button>}
            </div>
          </div>
        </Typography>
      </Box>
    </Modal>
  );
}